import "./index.css";
import { InspectionProvider, useInspection } from "./InspectionContext";
import { LoginGate } from "./LoginGate";
import { Footer, TopNav } from "./shared";
import { UploadScreen } from "./UploadScreen";
import { ProcessingScreen } from "./ProcessingScreen";
import { SummaryScreen } from "./SummaryScreen";

export function App() {
  return (
    <LoginGate>
      <InspectionProvider>
        <Shell />
      </InspectionProvider>
    </LoginGate>
  );
}

function Shell() {
  const { screen } = useInspection();
  return (
    <div className="min-h-screen bg-surface-light text-sixt-black">
      <TopNav />
      <main className="mx-auto max-w-[1280px] px-6 py-10">
        {screen === "upload" && <UploadScreen />}
        {screen === "processing" && <ProcessingScreen />}
        {screen === "summary" && <SummaryScreen />}
      </main>
      <Footer />
    </div>
  );
}

export default App;
